export const TierMap = {
    '1': {
        left: [
            { label: 'My Request', route: '/my_request' },
        ],
        search_enabled: true
    },
    '2': {
        left: [
            { label: 'My Request', route: '/my_request' },
            { label: 'Relationships', route: '/relationships' }
        ],
        search_enabled: true
    }
    //..etc
}
